import React from 'react';
import { ThemeProvider } from 'styled-components';

import DevError from '/shared/errors/DevError';

import GlobalStyle from '/shared/styled/GlobalStyle/GlobalStyleTest';
import { colourTheme } from '/shared/styled/Colours';

import PageError from '/shared/components/PageError';
import type { DisplayError } from '/shared/components/Error';
import { developmentMode } from '/shared/util/Statics';

const errorBoundaryTheme = {
  Colours: colourTheme,
  isDebug: false,
  target: {
    isConsumer: false,
    isBusiness: false,
    isCMPMain: false,
    isAirbp: false,
    value: '',
    hotjarUid: '',
  },
};

interface Props {
  children?: React.ReactNode;
}

interface State {
  hasError: boolean;
  error?: DisplayError;
}

export default class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false };

  static getDerivedStateFromError(error: DisplayError) {
    if (error instanceof DevError) {
      return { hasError: false };
    }
    return { hasError: true, error };
  }

  componentDidCatch() {
    // You can also log the error to an error reporting service
    // ...
  }

  render() {
    const { hasError } = this.state;
    const { children } = this.props;
    if (hasError) {
      return (
        <ThemeProvider theme={errorBoundaryTheme}>
          <GlobalStyle />
          <PageError error={developmentMode ? this.state.error : null} />
        </ThemeProvider>
      );
    }

    return children;
  }
}
